import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { componentWithFG } from '@jira/platform__utils-feature-gates-gate-component/src/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// Reuses the shared audit log "Inspect view" panel (Details + JSON tabs) from
// @jira/admin-pages__audit-logs.
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyAuditLogRightSidebar = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jsm-rovo-ai-audit-log-right-sidebar" */ '@jira/admin-pages__audit-logs/src/AuditLogRightSidebar.tsx'
		).then((m) => m.AuditLogRightSidebar),
	{ ssr: false },
);

function AsyncAuditLogRightSidebarInner(): React.JSX.Element {
	return (
		<JSErrorBoundary
			id="jsm-rovo-ai-audit-log-right-sidebar"
			packageName="jiraAdminPagesProductJsmAiGovernance"
			teamName="jsm-bumblebee"
			sendToPrivacyUnsafeSplunk
		>
			<Placeholder name="async-jsm-rovo-ai-audit-log-right-sidebar" fallback={<></>}>
				<LazyAuditLogRightSidebar />
			</Placeholder>
		</JSErrorBoundary>
	);
}

export const AuditLogRightSidebarAsync: React.FC<React.RefAttributes<unknown>> = componentWithFG(
	'enable-rovo-ai-audit-logs-for-jsm',
	AsyncAuditLogRightSidebarInner,
	() => null,
);
AuditLogRightSidebarAsync.displayName = 'AuditLogRightSidebarAsync';

export default AuditLogRightSidebarAsync;
